<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { sidebar_routes } from '@/config/sidebar-route';

const store = useStore();
const route = useRoute();
const secondaryNames = ['assistants', 'prompt', 'roles', 'members'];
const routes = computed(() => {
    const permissions = store.state.auth.permissions.data;
    return sidebar_routes.filter(item =>
        (!permissions['facebook_review.general'] || item.facebookReviewer) &&
        (item.permission === 'public' || permissions[item.permission]?.length)
    );
});
const primaryRoutes = computed(() => routes.value.filter(item => !secondaryNames.includes(item.name)));
const secondaryRoutes = computed(() => routes.value.filter(item => secondaryNames.includes(item.name)));
const isActive = item => route.path === item.link || route.path.startsWith(`${item.link}/`);
</script>

<template>
    <nav class="compact-header-menu" aria-label="Menu chính">
        <div class="d-none d-xl-flex align-items-center gap-1">
            <router-link v-for="item in primaryRoutes" :key="item.name" :to="item.link"
                class="compact-nav-link" :class="{ active: isActive(item) }">
                {{ item.label }}
            </router-link>
            <b-dropdown v-if="secondaryRoutes.length" text="Thêm" variant="link" no-caret
                toggle-class="compact-nav-link" :class="{ 'has-active-route': secondaryRoutes.some(isActive) }">
                <b-dropdown-item v-for="item in secondaryRoutes" :key="item.name" :to="item.link"
                    :active="isActive(item)">
                    {{ item.label }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <b-dropdown class="d-xl-none" text="Menu" variant="link" no-caret toggle-class="compact-nav-link">
            <b-dropdown-item v-for="item in routes" :key="item.name" :to="item.link" :active="isActive(item)">
                {{ item.label }}
            </b-dropdown-item>
        </b-dropdown>
    </nav>
</template>

<style scoped>
.compact-nav-link {
    display: inline-block;
    padding: 8px 10px;
    color: var(--vz-body-color);
    white-space: nowrap;
    font-size: 12px;
    border-radius: 4px;
    text-decoration: none;
}
.compact-nav-link:hover, .compact-nav-link.active {
    color: var(--vz-primary);
    background: rgba(var(--vz-primary-rgb), 0.08);
}
.has-active-route :deep(.dropdown-toggle) {
    color: var(--vz-primary);
}
</style>
